import { IconProp, RotateProp } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"
import formatQuantity from "@utils/formatQuantity"

import { ColorScheme } from "@particles/types"

import { ColorBadge } from "@atoms"

import { InventoryLevels } from "@constants/choices"

import { InventoryLevelBadgeProps } from "./InventoryLevelBadge.types"

interface LevelConfig {
    label: string
    colorScheme: Exclude<ColorScheme, "black" | "white">
    icon: IconProp
    iconRotation?: RotateProp
}

const LEVEL_CONFIG: Record<number, LevelConfig> = {
    [InventoryLevels.full]: {
        label: "Full",
        colorScheme: "jade",
        icon: faIcon({ name: "circle-check", style: "solid" }),
    },
    [InventoryLevels.limited]: {
        label: "Limited",
        colorScheme: "amber",
        icon: faIcon({ name: "circle-half-stroke", style: "solid" }),
        iconRotation: 180,
    },
    [InventoryLevels.low]: {
        label: "Low",
        colorScheme: "orange",
        icon: faIcon({ name: "circle-quarter-stroke", style: "solid" }),
        iconRotation: 90,
    },
    [InventoryLevels.depleted]: {
        label: "Depleted",
        colorScheme: "tomato",
        icon: faIcon({ name: "ban", style: "solid" }),
    },
}

const UNKNOWN_CONFIG: LevelConfig = {
    label: "Unknown",
    colorScheme: "gray",
    icon: faIcon({ name: "circle-dashed", style: "solid" }),
}

export default function InventoryLevelBadge(props: InventoryLevelBadgeProps) {
    const { status, quantity, quantityOnHand, desired, size = "md" } = props

    const { label, colorScheme, icon, iconRotation } = LEVEL_CONFIG[status] ?? UNKNOWN_CONFIG

    const tooltip = `Inventory level\nOn hand: ${formatQuantity(quantityOnHand)} / Desired: ${formatQuantity(desired)}`

    return (
        <ColorBadge
            colorScheme={colorScheme}
            size={size}
            variant="icon"
            icon={icon}
            iconRotation={iconRotation}
            tooltip={tooltip}
        >
            {`${label}: ${formatQuantity(quantity)}/${formatQuantity(desired)}`}
        </ColorBadge>
    )
}
